import React from "react";
import { Bell, Eye, Smartphone } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const pointIcons = [Smartphone, Bell, Eye];

export default function PainPointsSection() {
  const { t } = useLanguage();
  const copy = t("kylendar.pain");

  return (
    <section id="pain-points" className="home-wash relative bg-gradient-to-b from-[#effcf6] via-white to-[#e7f8ef] py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="home-section-mark mx-auto max-w-2xl text-center">
          <p className="home-eyebrow">{copy.eyebrow}</p>
          <h2 className="home-title mt-3">{copy.title}</h2>
        </div>

        <div className="mx-auto mt-14 grid max-w-5xl gap-0 overflow-hidden border-y border-brand-100 sm:grid-cols-3">
          {pointIcons.map((Icon, index) => {
            const [title, body] = copy.points[index];
            return (
            <article key={title} className="group relative border-b border-brand-100 bg-white/55 p-6 text-center transition-colors hover:bg-white sm:border-b-0 sm:border-r sm:p-7 sm:text-left sm:last:border-r-0">
              <div className="flex h-14 items-center justify-center gap-3 sm:justify-start">
                <span className="font-display text-5xl font-extrabold tracking-[-0.08em] text-brand/25 transition-colors group-hover:text-brand/45">
                  0{index + 1}
                </span>
                <div className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-brand-100 bg-brand-50 text-brand-700 shadow-[0_8px_18px_-14px_rgba(8,122,88,.35)]">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
              </div>
              <h3 className="mt-4 font-display text-base font-bold text-slate-950">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-slate-500">{body}</p>
            </article>
            );
          })}
        </div>

        <p className="mx-auto mt-12 max-w-xl text-center text-sm leading-6 text-slate-600">
          {copy.closing}
        </p>
      </div>
    </section>
  );
}
